type CurrencyType = '₹' | '$' | '€';

export const currency: CurrencyType = '$';

export const currentYear = new Date().getFullYear();

export const developedByLink = '';
export const developedBy = 'Coderthemes'; // change/remove if you don't want to show this

export const contactUs = '';
export const buyLink = '';

// If you don't host under a subfolder, make this empty string:
export const basePath = '';

export const DEFAULT_PAGE_TITLE = 'Grease Ducks CRM';

// Replace with your backend URL if needed
export const API_BASE_PATH = '';

export const colorVariants = [
  'primary', 'secondary', 'success', 'danger', 'warning', 'info',
  'dark', 'purple', 'pink', 'orange', 'light', 'link',
];

export const companyLegal = 'Grease Ducks Ltd.';
export const copyrightText = `© ${companyLegal} ${currentYear}`;
